import CompanyDocumentListView from "@/views/company/documents/CompanyDocumentListView";

export default [
  {
    name: "pages.company.documents",
    path: "documents",
    component: CompanyDocumentListView
  },
  
  
];
